const notAllowedBrowsers = JSON.parse(import.meta.env.VITE_BROWSER_LIST);
window.OutdatedBrowsers.check({ notAllowedBrowsers, page: { applicationTitle: 'Money Markets', type: 'auto' } });
